export default [
  {
    path: '/publicPage/transportationPlanManagement',
    name: 'transportationPlanManagement',
    component: () => import(/* webpackChunkName: "order-center" */ './transportPlanManage.vue'),
    meta: {
      authPass: true,
      title: '运输计划管理',
      noTitle: true,
      headerId: 'myFortune'
    }
  },
  {
    path: '/publicPage/transportationPlanManagementDetail',
    name: 'transportationPlanManagementDetail',
    component: () => import(/* webpackChunkName: "common" */ './transportationPlanManagementDetail.vue'),
    meta: {
        authPass: true,
        title: '运输计划管理详情',
        noTitle: true,
        headerId: 'myFortune'
    }
}
];